<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Laporan Tahunan</h2>
    <Widget customHeader>
      <div>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between">
          <div>
            <button type="button" class="btn btn-primary mr-1" @click="$router.push('/app/laporan-tahunan/form')">
              <i class="fa fa-plus"></i> Tambah
            </button>
            <button type="button" class="btn btn-success" @click="exportData">
              <i class="fa fa-file-text-o"></i> Excel
            </button>
          </div>
          <div class="d-flex">
            <div class="d-flex">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mr-2 mb-0">Search: </label>
                <input
                  v-model="search.value"
                  type="text"
                  class="form-control"
                  id="search"
                />
              </div>
              <div>
                <select v-model="search.field" class="form-control">
                  <option value="nama_pemegang">Nama Pemohon</option>
                  <option value="jenis_kegiatan">Jenis Kegiatan</option>
                  <option value="nomor_kkprl">Nomor</option>
                  <option value="tahun_laporan">Tahun Laporan</option>
                  <option value="tanggal_submit_laporan">Tgl. Pelaporan</option>
                  <option value="tanggal_penilaian">Tgl. Penilaian</option>
                  <option value="nilai">Nilai</option>
                  <option value="total_skor">Skor</option>
                  <option value="kategori_penilaian">Kategori</option>
                  <option value="masa_berlaku">Masa Berlaku</option>
                  <option value="status_laporan">Status</option>
                </select>
              </div>
            </div>
            <div class="d-flex ml-4">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mb-0">Sort By: </label>
              </div>
              <div>
                <select v-model="sort.field" class="form-control">
                  <option value="createdAt">Tgl. Dibuat</option>
                  <option value="tahun_laporan">Tahun Laporan</option>
                  <option value="tanggal_submit_laporan">Tgl. Pelaporan</option>
                  <option value="tanggal_penilaian">Tgl. Penilaian</option>
                  <option value="masa_berlaku">Masa Berlaku</option>
                </select>
              </div>
              <div class="ml-2">
                <select v-model="sort.direction" class="form-control">
                  <option value="DESC">DESC</option>
                  <option value="ASC">ASC</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <table id="tabel_laporan_tahunan" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Nomor Izin Terbit</th>
              <th>Tahun Laporan</th>
              <th>Tgl. Pelaporan</th>
              <th>Lokasi</th>
              <th>Nilai</th>
              <th>Skor</th>
              <th>Kategori</th>
              <th>Masa Berlaku</th>
              <th>Status</th>
              <th>Tgl. Penilaian</th>
              <th>Unduh File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in dataLaporan"
              :key="index"
              :class="[
                {
                  'text-danger': data.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
                },
              ]"
            >
              <!-- No -->
              <td>{{ index + pagination.firstInPage }}</td>
              <!-- Nama Pemohon -->
              <td>
                <div style="width: 300px; white-space: normal">
                  {{ data.nama_pemegang || '-' }}
                </div>
              </td>
              <!-- Jenis Kegiatan -->
              <td>{{ data.jenis_kegiatan || '-' }}</td>
              <!-- Nomor Izin Terbit -->
              <td>{{ data.nomor_kkprl || '-' }}</td>
              <!-- Tahun Laporan -->
              <td>{{ data.tahun_laporan || '-' }}</td>
              <!-- Tgl. Pelaporan -->
              <td>
                {{ data.tanggal_submit_laporan ? formatDate(data.tanggal_submit_laporan, 'DD MMMM YYYY') : '-' }}
              </td>
              <!-- Lokasi -->
              <td>{{ data.provinsi || '-' }}</td>
              <!-- Nilai -->
              <td>{{ data.nilai || '-' }}</td>
              <!-- Skor -->
              <td>{{ data.total_skor || '-' }}</td>
              <!-- Kategori -->
              <td>{{ data.kategori_penilaian || '-' }}</td>
              <!-- Masa Berlaku -->
              <td>{{ formatDate(data.masa_berlaku, 'DD MMMM YYYY') || data.masa_berlaku || '-' }}</td>
              <!-- Status -->
              <td>{{ data.status_laporan_t }}</td>
              <!-- Tgl. Penilaian -->
              <td>
                {{ data.tanggal_penilaian ? formatDate(data.tanggal_penilaian, 'DD MMMM YYYY') : '-' }}
              </td>
              <!-- Unduh File -->
              <td>
                <div style="width: 250px" class="row">
                  <div class="col-8">
                    <select style="width: 150px; margin-right: 10px" class="form-select" v-model="data.selected_file">
                      <option disabled selected value="">- Pilih File -</option>
                      <option
                        :value="`${data.id_file_tanda_terima_laporan}`"
                        :disabled="!data.id_file_tanda_terima_laporan"
                      >
                        Tanda Terima
                      </option>
                      <option
                        :value="`${data.id_filename_hasil_penilaian}`"
                        :disabled="!data.id_filename_hasil_penilaian"
                      >
                        Hasil Penilaian
                      </option>
                      <option :value="`${data.id_file_sertifikat}`" :disabled="!data.id_file_sertifikat">
                        Sertifikat Apresiasi
                      </option>
                      <option :value="`${data.id}:merged`" :disabled="data.status_laporan !== 'Selesai'">
                        Dokumen Laporan Lengkap
                      </option>
                    </select>
                  </div>
                  <div class="col-4 d-flex align-items-center">
                    <span v-if="data.selected_file !== '#'">
                      <a href="#" @click="unduhFile(data.selected_file)">
                        <i class="fa fa-download" style="font-size: 20px"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </td>
              <!-- Aksi -->
              <td>
                <div style="width: 150px">
                  <b-button-toolbar>
                    <button
                      v-if="
                        data.status_laporan === 'Draft' ||
                        data.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
                      "
                      class="pulse-glow-button m-1"
                      @click="finalisasiLaporan(data)"
                    >
                      <i class="fa fa-check"></i> Submit
                    </button>
                    <b-button
                      v-if="data.status_laporan !== null && data.status_laporan !== 'Draft'"
                      size="sm"
                      variant="primary"
                      :class="[
                        'm-1 btn-tracking',
                        {
                          'tracking-badge':
                            data.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
                        },
                      ]"
                      @click="showModalTracking(data.id, index)"
                    >
                      <i class="fa fa-search"></i> Tracking
                    </b-button>
                    <b-button
                      v-if="getStatusLaporan(data) >= 4"
                      size="sm"
                      style="background-color: #ff6d1f"
                      :class="['text-white m-1', { 'btn-diskusi-active': data.unread_chat }]"
                      @click="toggleModalChat(data)"
                    >
                      <i class="bi bi-chat"></i> Diskusi
                    </b-button>
                    <template
                      v-if="
                        data.status_laporan === null ||
                        data.status_laporan === 'Draft' ||
                        data.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
                      "
                    >
                      <b-button size="sm" variant="warning" class="m-1" @click="editLaporan(data.id)">
                        <i class="fa fa-edit"></i> Edit
                      </b-button>
                      <b-button size="sm" variant="danger" class="text-white m-1" @click="deleteLaporan(data.id)">
                        <i class="fa fa-trash-o"></i> Hapus
                      </b-button>
                    </template>
                    <b-button
                      v-else
                      size="sm"
                      variant="info"
                      class="m-1"
                      @click="$router.push(`/app/laporan-tahunan/tinjau?id_laporan=${data.id}`)"
                    >
                      <i class="fa fa-eye"></i> Tinjau
                    </b-button>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between mt-4">
          <div>
            <template v-if="pagination.total">
              Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ? pagination.limit*pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
            </template>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'first'})">
                  <span aria-hidden="true">Awal</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'prev'})">
                  <span aria-hidden="true">Sebelumnya</span>
                </a>
              </li>
              <li 
                v-for="i in pagination.pageNumber" 
                class="page-item"
              >
                <a :class="['page-link', {'active': i === `${pagination.currentPage}`}]" href="#" @click="changePage({page: i})">{{ i }}</a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'next'})">
                  <span aria-hidden="true">Selanjutnya</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'last'})">
                  <span aria-hidden="true">Akhir</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Widget>

    <b-modal id="modal-tracking" title="Tracking Laporan Tahunan" size="lg" scrollable>
      <template>
        <ul class="timeline">
          <li v-for="(item, index) in trackingPermohonan">
            <span class="eventIcon eventIconPrimary"></span>
            <section class="event p-0">
              <div class="m-3">
                <span class="thumb-xs avatar pull-left me-sm-1"> </span>
                <h5 class="eventHeading">
                  <a href="#">{{ item.status_laporan }}</a>
                </h5>
                <small>{{ item.nama_pemegang }}</small>
                <p class="fs-sm text-muted">
                  {{ formatDate(item.createdAt, 'HH:mm - DD MMMM YYYY') }}
                </p>
                <div class="text-danger" v-html="item.catatan"></div>
              </div>
            </section>
          </li>
        </ul>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="danger" size="sm" class="float-right" @click="$bvModal.hide('modal-tracking')">
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>

    <ModalChat :data-laporan="selectedLaporan" />
  </div>
</template>

<style>
table.table.b-table > thead > tr > th[aria-sort='ascending']::after,
table.table.b-table > tfoot > tr > th[aria-sort='ascending']::after {
  opacity: 1;
  content: '\2191';
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}

#tabel_laporan_tahunan_info,
#tabel_laporan_tahunan_paginate,
#tabel_laporan_tahunan_filter {
  display: none;
}
</style>

<script>
import Widget from '@/components/Widget/Widget'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import { exportToExcel, formatDate, openFileById } from '../../helper/helpernew'
import axios from 'axios'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import ModalChat from '../../components/ModalChat/ModalChat.vue'

export default {
  name: 'Dynamic',
  components: { Widget, ClassicEditor, vSelect, ModalChat },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      dataLaporan: [],
      dataPenilaian: [],
      dataPermohonan: [],
      trackingPermohonan: [],
      selectedLaporan: {},
      popoverShow: {},
      formCatatan: '',
      wygEditor: ClassicEditor,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'nama_pemegang',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
      debounceTerm: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatDate,
    openFileById,
    exportToExcel,

    onClose(id) {
      this.popoverShow[id] = false
    },

    showModalTracking(id, index) {
      axios
        .get(this.baseapiPengendalian + `api/status_laporan_tahunan?filter=id_laporan,=,${id}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          this.trackingPermohonan = res.data.data
        })
      this.$bvModal.show('modal-tracking')
    },

    async getData() {
      $('#tabel_laporan_tahunan').DataTable().destroy()
      await this.loadData()
    },

    async loadData() {
      // prettier-ignore
      const api = `api/laporan_tahunan`+
        `?page=${this.pagination.currentPage}`+
        `&filter=id_user,=,${this.user.id}${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_submit_laporan'||this.search.field==='tanggal_penilaian'||this.search.field==='total_skor'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`
      axios
        .get(this.baseapiPengendalian + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataLaporan = this.getDataLaporanText(response.data?.data)
          this.loadDataRoomChat()
        })
        .catch((error) => {})
        .finally(() => {
          this.initDatatable()
        })
    },

    async loadDataRoomChat() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat_room?filter=id_pemrakarsa,=,${this.user.id}`,
        this.getApiOption(),
      )
      const setActiveRoomChat = new Set()
      for (const d of res.data.data) {
        if (!d.tt_chats[0].read && d.tt_chats[0].id_pengirim !== `${this.user.id}`) {
          setActiveRoomChat.add(Number(d.id_laporan))
        }
      }
      const result = []
      for (const d of this.dataLaporan) {
        if (setActiveRoomChat.has(d.id)) {
          d.unread_chat = true
        }
        result.push(d)
      }
      this.dataLaporan = result
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getData()
      $('html,body').scrollTop(1000)
    },

    async finalisasiLaporan(item) {
      const { value: accept } = await Swal.fire({
        title: 'Pakta Integritas',
        input: 'checkbox',
        text: 'Menyatakan bahwa laporan tahunan pemegang KKPRL yang kami sampaikan adalah benar sesuai dengan ketentuan yang berlaku.',
        inputPlaceholder: 'Laporan yang sudah disubmit tidak dapat diedit kembali',
        confirmButtonText: 'Setuju',
        inputValidator: (result) => {
          return !result && 'Pakta integritas wajib disetujui'
        },
      })
      if (!accept) return false

      const formData = {
        status_laporan: 'Laporan telah disubmit', 
      }
      if (item.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan') {
        formData.tanggal_submit_laporan = dayjs(new Date()).format('YYYY-MM-DD')
      }

      this.$loading(true)
      await axios
        .post(
          this.baseapiPengendalian + `api/laporan_tahunan/${item.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        .then((res) => {
          this.loadData()
          Swal.fire('Berhasil', 'Berhasil submit laporan tahunan', 'success')
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Gagal submit laporan tahunan', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    editLaporan(id) {
      this.$router.push(`/app/laporan-tahunan/form?id_laporan=${id}`)
    },

    deleteLaporan(id) {
      Swal.fire({
        title: 'Apakah Anda yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + 'api/laporan_tahunan/' + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire('Berhasil', 'Berhasil menghapus laporan tahunan', 'success')
              $('#tabel_laporan_tahunan').DataTable().destroy()
              this.loadData()
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal menghapus laporan tahunan', 'error')
            })
        }
      })
    },

    async unduhFile(d) {
      const [id_dokumen, type] = d.split(':')
      Swal.fire('Unduh File Dalam Proses', 'Mohon untuk tidak menutup atau me-refresh halaman', 'info')
      if (type === 'merged') {
        await this.getCombinedPDF(id_dokumen)
      } else {
        await this.openFileById(id_dokumen)
      }
      this.$toasted.success('Unduh file selesai')
    },

    async getCombinedPDF(id_laporan) {
      return axios
        .get(
          `${this.baseapiPengendalian}api/laporan_tahunan/getCombinedPDF/${id_laporan}`,
          this.getApiOption({ responseType: 'blob' }),
        )
        .then((res) => {
          const file = new Blob([res.data], { type: res.data.type })
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL, '_blank')
        })
    },

    calculateMasaBerlaku(masa_berlaku, terbit_kkprl) {
      const t_masa_berlaku = new Date(masa_berlaku).getDate()
      if (!isNaN(t_masa_berlaku)) {
        const d1 = new Date(masa_berlaku)
        const d2 = new Date(terbit_kkprl)
        return `${Math.abs(d1.getFullYear() - d2.getFullYear())} tahun`
      } else {
        return '-'
      }
    },

    initDatatable() {
      setTimeout(() => {
        var t = $('#tabel_laporan_tahunan').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          buttons: [],
        })
      }, 300)
    },

    exportData() {
      // prettier-ignore
      const api = `api/laporan_tahunan`+
        `?page=${this.pagination.currentPage}`+
        `&filter=id_user,=,${this.user.id}${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_submit_laporan'||this.search.field==='tanggal_penilaian'||this.search.field==='total_skor'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`+
        `&limit=0`
      axios
        .get(this.baseapiPengendalian + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = this.getDataLaporanText(response.data?.data).map((d, i) => {
            return {
              no: i + 1,
              ...d,
            }
          })
          const header = {
            no: 'No',
            nama_pemegang: 'Nama Pemohon',
            jenis_kegiatan: 'Jenis Permohonan',
            nomor_kkprl: 'Nomor Izin Terbit',
            tahun_laporan: 'Tahun Laporan',
            tanggal_submit_laporan: 'Tgl. Pelaporan',
            provinsi: 'Lokasi',
            nilai: 'Nilai',
            total_skor: 'Skor',
            kategori_penilaian: 'Kategori',
            masa_berlaku: 'Masa Berlaku',
            status_laporan_t: 'Status',
            tanggal_penilaian: 'Tgl. Penilaian',
          }
          this.exportToExcel({
            data,
            header,
            fileName: `Laporan Tahunan ${formatDate(new Date(), 'YYYY-MM-DD')}`,
          })
        })
        .catch((error) => {})
    },

    getDataLaporanText(data) {
      if (!data) return []
      return data.map((d) => {
        const status_laporan_t = d.status_laporan || 'Laporan tahunan belum lengkap'
        const masa_berlaku = d.masa_berlaku ? d.masa_berlaku : d.status_laporan === 'Selesai' ? 'Selama Menjalankan Kegiatan Usaha' : ''
        return {
          ...d,
          selected_file: '#',
          provinsi: d.provinsi ? d.provinsi.join(', ') : '-',
          status_laporan_t,
          masa_berlaku,
        }
      })
    },

    toggleModalChat(d) {
      d.unread_chat = false
      this.selectedLaporan = d
      this.$bvModal.show('modal-chat')
    },

    getStatusLaporan(record) {
      const status = [
        'Draft',
        'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
        'Laporan telah disubmit',
        'Laporan telah diterima',
        'Laporan sedang dalam proses penilaian',
        'Selesai',
      ]
      return status.findIndex((d) => d === record.status_laporan)
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },

  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getData()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getData()
      },
      deep: true,
    },
  },
}
</script>

<style src="./Elements.scss" lang="scss" />

<style scoped>
.pulse-glow-button {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 0.45rem;
  background-color: #4caf50;
  color: white;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;
  animation: pulse-glow 2s infinite ease-in-out;
}

.pulse-glow-button:hover {
  background-color: #45a049;
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 5px 0px rgba(76, 175, 80, 0.7);
  }
  50% {
    box-shadow: 0 0 20px 8px rgba(76, 175, 80, 0.7);
  }
  100% {
    box-shadow: 0 0 5px 0px rgba(76, 175, 80, 0.7);
  }
}

.btn-tracking {
  position: relative;
}

.btn-tracking.tracking-badge::after {
  content: '';
  position: absolute;
  top: 0px;
  right: 0px;
  width: 10px;
  height: 10px;
  background: #c93626;
  border-radius: 100%;
  transform: translate(50%, -50%);
  animation: pulse-badge-glow 2s infinite ease-in-out;
}

@keyframes pulse-badge-glow {
  0% {
    box-shadow: 0 0 3px 0px rgba(201, 54, 38, 0.7);
  }
  50% {
    box-shadow: 0 0 8px 4px rgba(201, 54, 38, 0.7);
  }
  100% {
    box-shadow: 0 0 3px 0px rgba(201, 54, 38, 0.7);
  }
}

.btn-diskusi-active::after {
  content: '';
  position: absolute;
  top: 0px;
  right: 0px;
  width: 10px;
  height: 10px;
  background: #c93626;
  border-radius: 100%;
  transform: translate(50%, -50%);
  animation: pulse-badge-glow 2s infinite ease-in-out;
}
</style>
